import { useContext, useState } from "react";
import { Button, Card, Col, Form, FormControl, InputGroup, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsSearch } from "react-icons/bs";
import Post from "../../api/Post";
import { CHECK_PATIENT_BY_EMAIL, UPDATE_PATIENT_BY_IDAPP_IDPAT } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import CompletePatientInfo from "./CompletePatientInfo";

function SearchPatientOnDemand({t, setCita, cita}){
    const [searchingPatient, setSearchingPatient] = useState(false)
    const {auth} = useContext(authContext)
    const [searchPaciente, setSearchPaciente] = useState('')
    const [itemsPacientes, setItemsPacientes] = useState([])
    const [showModalPaciente, setShowModalPaciente] = useState(false)
    const [idSelectPatient, setIdSelectPaient] = useState(null)
    const [submitChangePatient, setSubmitChangePatient] = useState(false)
    const [showFormPatient, setShowFormPatient] = useState(false)
    const handleCloseModalPaciente = () => {
        setIdSelectPaient(null)
        setShowModalPaciente(false)
    }

    const handleBuscarPaciente = () =>{
        //console.log(searchPaciente)
        setSearchingPatient(true)
        if(searchPaciente){
            Post({url: `${CHECK_PATIENT_BY_EMAIL}/${searchPaciente}`, data: {}, access_token: auth.data.access_token, header: true})
            .then(response=>{
                console.log(response)
                if(response.data.data.response.length > 0){
                    setItemsPacientes(response.data.data.response)
                    setShowModalPaciente(true)
                    setSearchingPatient(false)
                }else{
                    setSearchingPatient(false)
                    setShowFormPatient(true)
                    //no encontro el paciente
                }
            })
            .catch(error=>{
                console.log(error)
                setSearchingPatient(false)
                setShowFormPatient(true)
                //no encontro el paciente
            })
        }        
    }

    const selectPatient = e =>{
        //console.log(idSelectPatient)
        //ajustamos la cita con este id de paciente
        setSubmitChangePatient(true)
        Post({url: `${UPDATE_PATIENT_BY_IDAPP_IDPAT}/${cita.id}/${idSelectPatient}`, data: {}, access_token: auth.data.access_token, header: true})
        .then(response=>{
            console.log(response)
            //actualizado el paciente en la cita
            //...setPaciente(response.data.patientDTO)
            setCita(prev=> ({
                ...prev,
                patientDTO: response.data.data.patientDTO,
                ageDTO: response.data.data.ageDTO
            }))
            setShowModalPaciente(false)
        })
        .catch(error=>{
            console.log(error)
            setSubmitChangePatient(false)
            //setShowModalPaciente(false)
        })
    }

    return (
        <>
            <Row className="my-3">
                <Col xs="12" md="12">
                    <Card className="shadow-1">
                        <Card.Body>
                            <Form.Group>
                                <Form.Label>Buscar paciente por email</Form.Label>
                                <InputGroup>
                                    <FormControl
                                        type="text"
                                        value={searchPaciente}
                                        onChange={e=>setSearchPaciente(e.target.value)}
                                        className="input-form"
                                    />
                                    <InputGroup.Append>
                                        <Button variant="secondary" className="px-3" onClick={handleBuscarPaciente}>
                                            {
                                                searchingPatient ?
                                                <div className="spinner-border text-light wh-1rem" role="status"><span className="sr-only">Loading...</span></div> :
                                                <BsSearch />
                                            }
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {
                showFormPatient &&
                <Row className="my-3">
                    <Col xs="12" md="12">
                        <CompletePatientInfo
                            cita={cita}
                            setCita={setCita}
                            emailPatient={searchPaciente}
                            setShowFormPatient={setShowFormPatient}
                        />
                    </Col>
                </Row>
                

            }

            <Modal show={showModalPaciente} onHide={handleCloseModalPaciente} size="lg" className="border-0">
                <Modal.Body className="position-relative overflow-hidden">
                    {submitChangePatient && <SimpleLoad />}
                    <h5>Seleccionar paciente</h5>
                    {
                        itemsPacientes.map((item,i)=>(
                        <div key={i} className={`simple-box mb-2 ${idSelectPatient === item.id && 'active'}`} onClick={e=>setIdSelectPaient(item.id)}>
                            <Row>
                                <Col xs="12" md="12">
                                    <span className="d-block font-size-09rem font-weight-bold-600">{`${item.name}  ${item.middleName ?? ''} ${item.lastName} ${item.seccondSurname ?? ''}`}</span>
                                    <span className="d-block font-size-08rem">{item.patientRelationshipDTO?.name}</span>
                                </Col>
                            </Row>
                        </div>
                        ))
                    }

                    <div className="mt-2 text-right">
                        <Button variant="outline-secondary" size="sm" onClick={selectPatient}>Aceptar</Button>
                    </div>
                    
                </Modal.Body>
            </Modal>
        
        </>
    )
}

export default withTranslation()(SearchPatientOnDemand)